<template>
  <div class="column_center_around link_button not_login" v-if="!isLogin">
    <text class="button-icon text-[40px] w-10 h-10">{{ buttonItem1.icon }}</text>
    <p>{{ buttonItem1.name }}</p>
    <div v-if="subInfo" class="row_center_center sub_info">
      <p>{{ subInfo }}</p>
    </div>
  </div>

  <RouterLink :to="{ name: buttonItem1.routerName, params: { store: storeCode } }" class="routerLink"
    v-else-if="isLogin && !buttonItem1.lock">
    <div class="column_center_around link_button" :style="{ height: buttonSize }">
      <text class="button-icon text-[40px] w-10 h-10">{{ buttonItem1.icon }}</text>
      <p>{{ buttonItem1.name }}</p>
      <div v-if="subInfo" class="row_center_center sub_info">
        <p>{{ subInfo }}</p>
      </div>
    </div>
  </RouterLink>

  <!-- 暫時依照需求將部分選項 disable -->
  <div class="column_center_around link_button not_login" style="padding: 8px 0;" v-else-if="isLogin"
    :style="{ height: buttonSize }">
    <div class="row_center_end lock" v-if="buttonItem1.lock">
      <text class="button-icon text-2xl w-6 h-6" style="color: #D5AC00;"
        v-if="buttonItem1.lock === 'priority'">lock</text>
      <text class="button-icon text-2xl w-6 h-6" style="color: #000;" v-else>lock</text>
    </div>
    <text class="button-icon text-[40px] w-10 h-10">{{ buttonItem1.icon }}</text>
    <!-- <div class="column_center_center" style="flex-grow: 1; width: 100%;"> -->
    <p>{{ buttonItem1.name }}</p>
    <!-- </div> -->

    <div v-if="subInfo" class="row_center_center sub_info">
      <p>{{ subInfo }}</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { RouterLink } from "vue-router";
export default {
  props: {
    buttonItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    buttonItem1() {
        const serviceTypeMap = {
            'LINE下單': 1,
            'LINE訂單': 1,
            '紅利積分': 3,
            '集點商城': 4,
            '優惠卷': 5,
            '保管紀錄': 6,
            '問卷': 7,
            '行銷活動': 8,
        }
        const serviceType = serviceTypeMap[this.buttonItem.name]
        if (serviceType !== undefined) {
            return {
                ...this.buttonItem,
                lock: this.isServiceEnabled(serviceType) ? '' : 'priority'
            }
        }
        return this.buttonItem;
    },
    isServiceEnabled() {
        return this.$store.getters['basic/isServiceEnabled']
    },
    buttonSize() {
      return this.buttonItem1.buttonSize === 'small' ? '95px' : '116px'
    },
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      vipLevel: 'vipLevel',
      totalPoints: 'totalPoints',
      storeCode: 'storeCode'
    }),
    buttonName() {
      return this.buttonItem1.name
    },
    subInfo() {
      if (this.buttonName === '會員') {
        if (this.isLogin && this.vipLevel >= 2) return 'VIP會員'
        return '會員'
      }
      if (this.buttonName === '紅利積分') {
        if (this.buttonItem1.lock) return ''  // 鎖定時不顯示點數
        if (!this.isLogin) return '-點可折'
        return `${this.totalPoints}點可折`
      }
      // TODO: 優惠卷功能尚未完成
      // if (this.buttonName === '優惠卷') {
      //   if (!this.isLogin) return '-張'
      //   return `${this.couponCount}張`
      // }
      return ''      
    }
  },
  methods: {
    router(path) {
      if (!this.isLogin) {
        return
      }
      if (this.buttonItem1.lock) {
        return
      }
      this.$router.push(path);
    },
  },
  components: { RouterLink },
};
</script>
<style lang="scss" scoped>
.link_button {
  border-radius: 16px;
  width: calc((90vw - 20px) / 3);
  height: 116px;
  padding: 14px 0 11px;
  background-color: #fff;
  border: 1px solid #eaeaea;

  p {
    font-size: 16px;
    font-weight: 500;
    font-family: PingFang SC;
    color: #000000;
    margin: 0;
  }
}

.routerLink {
  text-decoration: none;
}

.not_login {
  padding: 15px 0 5px;
  background-color: rgba(255, 255, 255, 0.4);

  p,
  text {
    color: rgba(0, 0, 0, 0.4);
  }
}

.sub_info {
  width: 92%;
  background-color: #eeeeee;
  padding: 5px 0;
  border-radius: 16px;

  p {
    color: #fd4f02;
    font-size: 13px;
    font-weight: 400;
    font-family: PingFang SC;
  }
}

.lock {
  width: 88%;
  height: 0;
  margin: none;
  padding: 0;

  text {
    margin: 0;
    margin-top: 15px;
  }
}
</style>
